<template>
  <v-dialog v-model="shower" persistent max-width="500px" scrollable>
    <v-card>
      <v-card-title
        class="black--text mb-3"
        :style="'background:' + _cardTitle"
      >
        <span>{{ $t("group_user.tips_edit") }}</span>
        <v-spacer></v-spacer>
        <v-btn
          color="#f05c5a"
          dark
          fab
          x-small
          class="elevation-0"
          @click="$emit('close')"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-form ref="formAddBuyer">
        <v-card-text>
          <br />
          <v-form ref="forms" class="elevation-0">
            <v-layout row wrap fill-height justify-center class="flex-custom">
              <v-flex xs12 lg12 mx-8>
                <v-text-field
                  color="teal"
                  v-model="source_system"
                  :label="$t('group_user.label_department')"
                  outlined
                  dense
                  clearable
                  disabled
                  :rules="[rulesObject.groupName]"
                ></v-text-field>
              </v-flex>
              <!-- <v-flex xs12 lg12 mx-8>
                <v-text-field
                  color="teal"
                  v-model="role"
                  :label="$t('setting_license.license')"
                  outlined
                  dense
                  clearable
                  :rules="[rulesObject.groupName]"
                ></v-text-field>
              </v-flex> -->
              <v-flex xs12 lg12 mx-8>
                <v-autocomplete
                  :items="list_user"
                  color="teal"
                  :label="$t('group_user.table_group_user')"
                  v-model="group_user"
                  item-text="name_th"
                  item-value="id"
                  dense
                  outlined
                  return-object
                  :menu-props="{ button: true, offsetY: true }"
                  multiple
                  :rules="[rulesObject.groupBranch]"
                >
                  <template v-slot:selection="{ item, index }">
                    <v-chip v-if="index === 0">
                      <span>{{ item.name_th }}</span>
                    </v-chip>
                    <span v-if="index === 1" class="grey--text text-caption">
                      (+{{ group_user.length - 1 }}
                      {{ $t("processlog.condition.other") }})
                    </span>
                  </template>
                </v-autocomplete>
              </v-flex>
              <v-flex xs12 lg12 mx-8>
                <v-select
                  :items="$t('group_user.list_status')"
                  color="teal"
                  :label="$t('group_user.table_status')"
                  v-model="status"
                  item-text="text"
                  item-value="value"
                  outlined
                  dense
                ></v-select>
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>
      </v-form>

      <!-- ปุ่มการทำงาน dialogBuyername  -->
      <v-card-actions class="pa-5 mb-2 mt-n5">
        <v-spacer></v-spacer>
        <v-btn class="px-5" color="#f05c5a" outlined @click="$emit('close')">
          {{ $t("create_invoice.dialogBuyername.button_close") }}
        </v-btn>
        <v-btn
          class="px-7"
          :color="pageDetailcolor"
          dark
          @click="fn_updaateGroup()"
          :loading="btnLoading"
        >
          {{ $t("create_invoice.dialogBuyername.button_save") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import authorization from "@/authorization/authorization.js";
import { mapGetters, mapState } from "vuex";

export default {
  props: ["show", "list_branch", "list_user", "_source_system", "item"],
  components: {},
  data: () => ({
    source_system: "",
    group_user: "",
    role: "",
    status: "",
    rulesObject: {
      groupName: (value) => !!value || "กรุณากรอก ชื่อหน่วยงาน",
      groupBranch: (value) =>
        !!value || "กรุณาเลือก ผู้ใช้งานที่มีสิทธิเข้าถึงข้อมูล",
      status: (value) => !!value || "กรุณาเลือก สถานะการใช้งาน",
      taxidFormat: (value) => {
        const pattern = /^(?=.*[0-9])(?=.{13,})/;
        return pattern.test(value) || "ต้องมีจำนวนตัวเลขอย่างน้อย 13 หลัก";
      },
    },
    btnLoading: false,
  }),
  watch: {
    show(value) {
      if (value) {
        this.source_system = this.item.source_system;
        this.group_user = this.item.group_user;
        this.role = this.item.role;
        this.status = this.item.config_status;
      } else {
        this.source_system = "";
        this.group_user = [];
        this.role = [];
        this.status = "";
      }
    },
  },
  computed: {
    ...mapGetters(["getter_dataBusiness_profile"]),
    ...mapState(["backgroudcolor", "pageDetailcolor", "cardTitle"]),
    taxid: {
      get() {
        return this.getter_dataBusiness_profile["id_card_num"];
      },
    },
    _pageDetailcolor: {
      get() {
        return this.pageDetailcolor;
      },
    },
    _cardTitle: {
      get() {
        return this.cardTitle;
      },
    },
    shower: {
      get() {
        return this.show;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
  },
  mounted() {},
  methods: {
    async fn_updaateGroup() {
      this.btnLoading = true;
      var payload = {
        taxid: this.taxid,
        tax_id: this.taxid,
        uid: this.item.uid,
        source_system: this.source_system,
        group_user: this.group_user,
        config_status: this.status,
      };
      var dataEncode = await authorization.encodeData(payload);
      var auth = await authorization.gentoken(this.taxid);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_R2_ABB_API + "config_source_systems/update",
          { data: dataEncode },
          { headers }
        )
        .then((res) => {
          this.btnLoading = false;
          if (res.data.status == "OK") {
            this.$emit("close");
            swal({
              title: this.$t("group_user.alert_update"),
              text: "",
              icon: "success",
            });

            this.$emit("reData");
          } else {
            swal(this.$t("alert.fail"), res.data.errorMessage, "error");
          }
        })
        .catch((error) => {
          this.btnLoading = false;
          if (error.response) {
            swal(
              this.$t("alert.fail"),
              this.$t("confirm.swal.catch_err") +
                JSON.stringify(error.response.data.errorMessage),
              "error"
            );
          } else if (error.request) {
            swal(
              this.$t("alert.fail"),
              this.$t("confirm.swal.catch_err") + error.request,
              "error"
            );
          } else {
            swal(
              this.$t("alert.fail"),
              this.$t("confirm.swal.catch_err") + error.message || error,
              "error"
            );
          }
        });
    },
  },
};
</script>
